import { CONNECTION_CLOSED_COUNT, CONNECTION_CLOSED, CONNECTION_OPENED } from '../actions/wsConnectionActions';
var initialState = {
  tries: 0,
  isConnected: false
};
export default function wsConnectionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case CONNECTION_CLOSED_COUNT:
      return Object.assign({}, state, {
        tries: payload
      });
    case CONNECTION_CLOSED:
    case CONNECTION_OPENED:
      return Object.assign({}, state, payload);
    default:
      return state;
  }
}